'use client';
import { Box, Stack, styled, Typography } from '@mui/material';

const MARGIN_TOP_OFFSET = 30;

export const ErrorContainer = styled(Box)`
  display: flex;
  text-align: center;
  height: 100vh;
  justify-content: space-between;
  flex-direction: column;
  margin-top: -${MARGIN_TOP_OFFSET}px;

  svg {
    margin: 0 auto;
    transform: scale(0.8);
  }
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

export const Title = styled(Typography)`
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const Pre = styled(Typography)`
  padding-bottom: ${({ theme }) => theme.spacing(5)};
  white-space: pre-line;
`;

export const Buttons = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const CopyErrorButton = styled(Stack)`
  cursor: pointer;
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(3)};
  right: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(1)};
`;
